import { EN_东风_BRANCH_NAME } from './branches/东风';
import { EN_欧莱雅_BRANCH_NAME } from './branches/欧莱雅';
import { EN_默认_BRANCH_NAME } from './branches/默认';

export enum EN_TENANT_NAME {
  默认 = '默认',
  东风 = '东风',
  欧莱雅 = '欧莱雅',
  上海电气 = '上海电气',
  重庆赫杰精密机械有限公司 = '重庆赫杰精密机械有限公司',
  宇通 = '宇通（勿删）',
  Thyssenkrupp = 'Thyssenkrupp',
  丹尼克尔 = '丹尼克尔',
  bozhong = '博众',
}

export const EN_STANDARD_BRANCH_NAME = {
  [EN_TENANT_NAME.默认]: EN_默认_BRANCH_NAME,
  [EN_TENANT_NAME.东风]: EN_东风_BRANCH_NAME,
  [EN_TENANT_NAME.欧莱雅]: EN_欧莱雅_BRANCH_NAME,
};
